
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen relative overflow-hidden bg-gradient-to-br from-[#0A1628] via-[#1A2847] to-[#0A1628]">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5a23f722bdeaa72b10bb8804f6caa599.jpg"
          alt="VPN Network Background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Animated Particles */}
      <div className="absolute inset-0">
        {[...Array(20)].map((_, i) => (
          <div
            key={i}
            className="absolute w-1 h-1 bg-[#00D9FF] rounded-full opacity-60 animate-pulse"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${2 + Math.random() * 2}s`
            }}
          />
        ))}
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 pt-32 pb-20">
        <div className="flex flex-col lg:flex-row items-center min-h-[80vh]">
          {/* Left Content */}
          <div className="w-full lg:w-3/5 text-center lg:text-left">
            <div className="mb-6">
              <span className="inline-block px-4 py-2 bg-[#00D9FF]/10 border border-[#00D9FF]/30 rounded-full text-[#00D9FF] text-sm font-semibold uppercase tracking-wider">
                Enterprise VPN Solution
              </span>
            </div>
            
            <h1 className="text-5xl lg:text-7xl font-bold text-white mb-6 leading-tight">
              Secure Your<br />
              <span className="text-[#00D9FF]">Digital World</span><br />
              With ELTROM
            </h1>
            
            <p className="text-xl text-[#B8C5D6] mb-10 max-w-2xl leading-relaxed">
              Professional VPN protection for businesses and individuals worldwide. 
              Experience uncompromised security with military-grade encryption.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start">
              <Button 
                variant="primary" 
                size="lg"
                onClick={() => scrollToSection('vpn')}
                className="group"
              >
                Get Started
                <i className="ri-arrow-right-line ml-2 group-hover:translate-x-1 transition-transform duration-200"></i>
              </Button>
              <Button 
                variant="secondary" 
                size="lg"
                onClick={() => scrollToSection('features')}
              >
                Learn More
                <i className="ri-play-circle-line ml-2"></i>
              </Button>
            </div>
          </div>

          {/* Right Content - Abstract Illustration */}
          <div className="w-full lg:w-2/5 mt-12 lg:mt-0 flex justify-center">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=3D%20abstract%20network%20visualization%20with%20glowing%20nodes%20and%20connections%2C%20futuristic%20cybersecurity%20shield%20floating%20in%20space%2C%20electric%20blue%20and%20white%20glowing%20effects%2C%20transparent%20background%20style%2C%20modern%20tech%20illustration%20with%20geometric%20patterns%20and%20data%20streams&width=600&height=600&seq=hero-illustration-01&orientation=squarish"
                alt="VPN Security Network"
                className="w-96 h-96 object-contain"
              />
              
              {/* Floating Elements */}
              <div className="absolute top-10 right-10 w-16 h-16 bg-[#00D9FF]/20 rounded-full flex items-center justify-center animate-bounce">
                <i className="ri-shield-check-line text-2xl text-[#00D9FF]"></i>
              </div>
              <div className="absolute bottom-20 left-0 w-12 h-12 bg-white/10 rounded-full flex items-center justify-center animate-pulse">
                <i className="ri-global-line text-xl text-white"></i>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
        <div className="animate-bounce">
          <i className="ri-arrow-down-line text-2xl text-white/60"></i>
        </div>
      </div>
    </section>
  );
}
